// tslint:disable
export var QueryStringMatch;
(function (QueryStringMatch) {
    // Exact
    QueryStringMatch[QueryStringMatch["Exact"] = 0] = "Exact";
    // Starts With
    QueryStringMatch[QueryStringMatch["StartsWith"] = 1] = "StartsWith";
    // Ends With
    QueryStringMatch[QueryStringMatch["EndsWith"] = 2] = "EndsWith";
    // Contains
    QueryStringMatch[QueryStringMatch["Contains"] = 3] = "Contains";
})(QueryStringMatch || (QueryStringMatch = {}));
QueryStringMatch['EXACT'] = 0;
QueryStringMatch['STARTSWITH'] = 1;
QueryStringMatch['ENDSWITH'] = 2;
QueryStringMatch['CONTAINS'] = 3;
//# sourceMappingURL=QueryStringMatch.js.map